// extracted by mini-css-extract-plugin
export var blink = "_9s-2";
export var cursor = "_9s-1";
export var reactMarkdown = "_9s-3";
export var streamingText = "_9s-0";